import React from "react";

export const Card: React.FC<{ children: React.ReactNode; className?: string; title?: string }> = ({
  children,
  className,
  title,
}) => (
  <div className={`card p-4 ${className ?? ""}`}>
    {title && <h3 className="mb-3 text-sm font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">{title}</h3>}
    {children}
  </div>
);

export const KpiCard: React.FC<{ label: string; value: string | number; sublabel?: string; accent?: "green" | "red" | "amber" | "blue" }> = ({
  label,
  value,
  sublabel,
  accent = "blue",
}) => {
  const accentClasses: Record<string, string> = {
    green: "text-green-600 dark:text-green-400",
    red: "text-red-600 dark:text-red-400",
    amber: "text-amber-600 dark:text-amber-400",
    blue: "text-accent-500",
  };
  return (
    <div className="card p-4">
      <p className="text-xs font-medium uppercase tracking-wide text-slate-500 dark:text-slate-400">{label}</p>
      <p className={`mt-2 text-2xl font-bold ${accentClasses[accent]}`}>{value}</p>
      {sublabel && <p className="mt-1 text-xs text-slate-400">{sublabel}</p>}
    </div>
  );
};
